import Select from "react-select";
import React, { useState, useEffect } from "react";
import { API_BASE_URL, GET_VSTORE_PROD } from "../../Config";
import SpinLoader from "../loader/SpinLoader";
import axios from "axios";
import Swal from "sweetalert2";

const AddExemptedProducts = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [ruleId, setRuleId] = useState(null);
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);

  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedStore, setSelectedStore] = useState(null);
  const [userDataSession, setUserDataSession] = useState(null);
  useEffect(() => {
    const userData = JSON.parse(sessionStorage.getItem("userData"));
    setUserDataSession(userData);
  }, []);

  const orgId = userDataSession?.OrgId;
  const userId = userDataSession?.UserId;

  useEffect(() => {
    const fetchRule = async () => {
      try {
        const res = await axios.get(
          `${API_BASE_URL}Settings/getRewardRules?OrgId=${orgId}`
        );
        if (res.data.Status && res.data.ResultData.length > 0) {
          setRuleId(res.data.ResultData[0].Id);
        } else {
            console.log("No Reward Rule Found");
        //   Swal.fire({
        //     icon: "warning",
        //     title: "No Reward Rule Found",
        //     text: "Please create a reward rule before adding exemptions.",
        //   });
        }
      } catch (err) {
        console.log(err,"Error while getting Reward")
      }
    };
    fetchRule();
  }, [orgId]);

  // 2. Load Categories from session (same as PrintBarcode)
  useEffect(() => {
    const categoryData = JSON.parse(
      sessionStorage.getItem("filteredDDLData_CATEGORY")
    );
    if (categoryData) {
      const options = categoryData.map((c) => ({
        value: c.ItemId,
        label: c.ItemValue,
      }));
      setCategories(options);
    }
  }, []);

  // 3. Load Stores (optional — only if you want to filter products by store)
  useEffect(() => {
    const storesData = JSON.parse(
      sessionStorage.getItem("filteredDDLData_Stores")
    );
    if (storesData && storesData.length > 0) {
      const options = storesData.map((s) => ({
        value: s.ItemId,
        label: s.ItemValue,
      }));
      setSelectedStore(options[0]);
    }
  }, []);

  useEffect(() => {
    if (!selectedStore || !ruleId) return;

    setLoading(true);
    const requestData = {
      OrgId: parseInt(orgId),
      CategoryId: selectedCategory?.value || 0,
      BarCode: "0",
      IsActive: 1,
      ProductId: 0,
      StoreId: selectedStore.value,
      IsForSale: 1,
      UserId: userId,
      Type: 1,
    };

    axios
      .post(`${API_BASE_URL}${GET_VSTORE_PROD}`, requestData)
      .then((res) => {
        if (res.data.Status) {
          const options = res.data.ResultData.map((p) => ({
            value: p.Id,
            label: p.ProductName,
          }));
          setProducts(options);
        }
      })
      .catch((err) => {
        console.error("Error loading products:", err);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to load products.",
        });
      })
      .finally(() => setLoading(false));
  }, [selectedCategory]);

  // Smart: Clear product when category selected
  const handleCategoryChange = (opt) => {
    setSelectedCategory(opt);
    setSelectedProduct(null);
  };

  const handleProductChange = (opt) => {
    setSelectedProduct(opt);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!ruleId)
      return Swal.fire({
        icon: "error",
        title: "Error",
        text: "Reward Rule ID is missing.",
      });
    if (!selectedCategory && !selectedProduct)
      return Swal.fire({
        icon: "warning",
        title: "Validation Error",
        text: "Please select either a category or a product.",
      });

    const payload = {
      RuleId: ruleId,
      ProductId: selectedProduct ? selectedProduct.value : "null",
      CategoryId: selectedCategory ? selectedCategory.value :null,
      CreatedBy: userId,
    };

    try {
      setSaving(true);
      await axios.post(`${API_BASE_URL}Settings/InsertExemptedItems`, payload);
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Exemption added successfully.",
      });

      setSelectedCategory(null);
      setSelectedProduct(null);
      document.querySelector("#addExemptedProducts .btn-close").click();
      window.location.reload();
    } catch (err) {
      const msg = err.response?.data?.ResultMessage || "Failed";
      Swal.fire({
        icon: "error",
        title: "Error",
        text: msg,
      });
      // toast.error(msg);
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      {saving && <SpinLoader />}

      <div className="modal fade" tabIndex="-1" id="addExemptedProducts">
        <div className="modal-dialog modal-md modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Exempted Items</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div className="modal-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-6 mb-3">
                    <label className="form-label">Category</label>
                    <Select
                      options={categories}
                      value={selectedCategory}
                      onChange={handleCategoryChange}
                      placeholder="All Categories"
                      isClearable
                    />
                  </div>

                  <div className="col-6 mb-3">
                    <label className="form-label">Product</label>
                    <Select
                      options={products}
                      value={selectedProduct}
                      onChange={handleProductChange}
                      placeholder={
                        loading ? "Loading products..." : "Search products..."
                      }
                      isLoading={loading}
                      isClearable
                      noOptionsMessage={() =>
                        "Select store & category first or type to search"
                      }
                    />
                  </div>

                  <div className="col-12">
                    <span className="text-muted small">
                      <strong>Note:</strong> Select <strong>either</strong>{" "}
                      Category or Product.
                      <br />
                      Category = All products in it will be exempted.
                    </span>
                  </div>
                </div>

                <div className="text-end mt-4">
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={saving || (!selectedCategory && !selectedProduct)}
                  >
                    {saving ? "Saving..." : "Save"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddExemptedProducts;
